import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import "react-datepicker/dist/react-datepicker.css";
import CircularProgress from '@mui/material/CircularProgress';
import {
	FormGroup,
	Label,
	Input,
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {   
    fetchFindingChart,
    editFindingChart,
    allSSTeam
 } from 'Actions';



class EditMSKElements extends React.Component {
   
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    static num1 = 0;

    UNSAFE_componentWillMount() {
        this.props.allSSTeam();
	}
   constructor(props) {
      
      super(props);
      this.state = {
            student: '',
            quarter:'',
            seldate:new Date(),
            actionvalue:'',
            addinnerdiv:true,
            mskassessor:'',
            mskskill:'',
            allergies:'',
            medicalhistory:'',
            medicalrecord:'',
            previousLength:0,
            valuelength:0,
            loader:false,
         };
        
   }
    

    editHandleSubmit(event){
        event.preventDefault();
        this.setState({loader:true });
        this.props.editFindingChart(event).then((data) => { 
            this.setState({loader:false });        
        if(data.status==1){
                setTimeout(this.props.onClick, 6000);
        }
        });
        
    }   
   
  
    handleInput(event) {
        const bullet = "\u2022";
        const inputValue = event.target.value;
        const cursorPosition = event.target.selectionStart;
        let lines = inputValue.split('\n');
      
        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];
          if (!line.trim().startsWith(bullet)) {
            lines[i] = `${bullet} ${line.trimLeft()}`;
          }
        }
      
        let newValue = lines.join('\n');
        if (event.nativeEvent.inputType === 'deleteContentBackward') {
          if (cursorPosition === 0) {
            const lineIndex = newValue.substr(0, cursorPosition).split('\n').length - 1;
            if (lineIndex > 0) {
              const linesArray = newValue.split('\n');
              linesArray.splice(lineIndex, 1);
              newValue = linesArray.join('\n');
            }
          } else if (newValue[cursorPosition - 1] === bullet && (cursorPosition === newValue.length || newValue[cursorPosition] === '\n')) {
            newValue = newValue.slice(0, cursorPosition - 2) + newValue.slice(cursorPosition);
          }
        }
      
        event.target.value = newValue;
      
        this.setState({
          previousLength: newValue.length,
        });
      }
  

   render() {
      
      const { findchartresponse, ssteamlists, loading} = this.props;
      const studentname=findchartresponse.student; 
     
        const styles = {
            buttonProgress: {
                color: "blue",
                position: 'absolute',
                top: '65%',
                left: '50%',
                marginTop: -15,
                marginLeft: -15,
            },
            wrapper: {
                position: 'relative',
                textAlign:"center"
            },
        };

      return (
           <div>
               <div className="col-lg-12">
                     <form autoComplete="off" id="editassessmentform" onSubmit={(e)=>this.editHandleSubmit(e)}>
                        <div className="row">
                            <div className="col-sm-12 col-lg-6" style={{margin:"0 auto"}}>
                            <RctCollapsibleCard heading="Edit MSK Findings">   
                                        <div className="row float-right"> 
                                        <button type="button" className="mr-3 mb-3 btn btn-outline-warning float-right" onClick={this.props.onClick} >Back</button>
                                        </div>                           
                                    <div className="row">
                                            
                                        <div className="col-sm-12 col-lg-8"> 
                                             <h3>Name : {studentname}</h3>   
                                        </div>   
                                        
                                        <div className="col-sm-12 col-lg-8">
                                            <h3>Date : {findchartresponse.cdate}</h3>                                         
                                        </div>  
                                        <div className="col-sm-12 col-lg-6 col-xl-12">
                                            <FormGroup>
                                                <Label for="Select">Red Flags *</Label>
                                                <textarea rows="3" type="text" name="redflags" id="redflags" className="form-control form-control-alternative" defaultValue={findchartresponse.sfc_redflags} required onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label for="Select">Previous Injury (If any )</Label>
                                                <textarea rows="3" type="text" name="previousinjury" id="previousinjury" className="form-control form-control-alternative" defaultValue={findchartresponse.sfc_previousinjury} onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup>
                                        </div>    
                                        <div className="col-sm-12 col-lg-8">   
                                            <FormGroup>
                                                <Label for="Select">Radiological Investigations Reports *</Label>
                                                    <select name="investigation" id="investigation" defaultValue={findchartresponse.sfc_investigations} className="form-control form-control-alternative" required>
                                                          <option value=""></option>
                                                          <option value="Submitted">Submitted</option>
                                                          <option value="Awaited">Awaited</option>
                                                          <option value="NA">NA</option>
                                                          <option value="Other">Other</option>
                                                    </select>
                                            </FormGroup>  
                                        </div>    
                                        <div className="col-sm-12 col-lg-6 col-xl-12">            
                                            <FormGroup>
                                                <Label for="Select">Note For Coaching Team</Label>
                                                <textarea rows="3" type="text" name="coachteam" id="coachteam" className="form-control form-control-alternative" defaultValue={findchartresponse.sfc_notes_coachteam} onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup> 
                                            <FormGroup>
                                                <Label for="Select">Note for S&C Team</Label>
                                                <textarea rows="3" type="text" name="scteam" id="scteam" className="form-control form-control-alternative" defaultValue={findchartresponse.sfc_notes_scteam} onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup> 
                                            <FormGroup>
                                                <Label for="Select">Note For Team TSG</Label>
                                                <textarea rows="3" type="text" name="tsgteam" id="tsgteam" className="form-control form-control-alternative" defaultValue={findchartresponse.sfc_notes_tsgteam} onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup> 
                                            <div className="col-sm-12 col-lg-8">   
                                                <FormGroup>
                                                    <Label for="Select">Submitted By *</Label>
                                                        <select name="submittedby" id="submittedby" defaultValue={findchartresponse.sfc_submittedby} className="form-control form-control-alternative" required>
                                                            <option value=""></option>
                                                            {ssteamlists.map((teamval) => (   
                                                                findchartresponse.sfc_submittedby==teamval.sctID ?                                                       
                                                                <option value={teamval.sctID} selected>{teamval.sc_name}</option>  
                                                                : <option value={teamval.sctID} selected>{teamval.sc_name}</option>                                                           
                                                            ))}
                                                        </select>
                                                </FormGroup>  
                                            </div>
                                            <div className="form-group" style={styles.wrapper}> 
                                                <input type="hidden" name="eid" id="eid" value={findchartresponse.sfcID}></input>
                                                <button type="submit" className="mr-3 mb-3 btn btn-outline-primary" disabled={this.state.loader} >Update</button>
                                                    {this.state.loader && <CircularProgress size={24} style={styles.buttonProgress} />}   
                                                    <button type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} >Back</button> 
                                            </div>
                                        </div>    
                                    </div>
                            </RctCollapsibleCard>  
                            </div> 
                            
                        </div>    
                     </form> 
                  </div>
         </div>
      );
   }
}


const mapStateToProps = ({ findingchart, ssteam }) => {
    const { findchartresponse, loading } = findingchart;
    const { ssteamlists } = ssteam;
    return { findchartresponse, ssteamlists, loading };
}

export default connect(mapStateToProps, {
    allSSTeam,
    fetchFindingChart,
    editFindingChart,
    
})(EditMSKElements); 